import { useEffect, useState } from 'preact/hooks'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'

/**
 * Custom hook for tracking page changes.
 * @returns {Object} An object containing the loaded pages as an array and a function to set the loaded pages.
 */
export function usePageTracker() {
  const { options, results } = useSearchspringContext()
  const page = options.get('page')
  const filters = options.get('filters')
  const sort = options.get('sort')
  const query = options.get('query')
  const [loadedPages, setLoadedPages] = useState([])

  useEffect(() => {
    if (!results?.pagination?.currentPage || loadedPages.includes(results?.pagination?.currentPage)) return

    setLoadedPages((prev) => {
      const next = new Set(prev)
      next.add(results?.pagination?.currentPage)
      const sortedArray = [...next].sort((a, b) => a - b)
      return sortedArray
    })
  }, [results?.pagination?.currentPage])

  // Filter or sort changes, reset the loaded pages
  useEffect(() => {
    if ((filters || sort || query) && page === 1) {
      setLoadedPages([1])
    }
  }, [filters, sort, query])

  return { loadedPages, page }
}
